/** How many contacts one "Select 20" click adds within a grouped table. */
export const GROUP_BATCH_SELECT_SIZE = 20;

/**
 * Next `limit` contacts of a group, in display order, that are not already selected.
 * Duplicates in `contacts` (a page loaded twice) are ignored.
 */
export function pickNextUnselected(contacts = [], selectedIds = new Set(), limit = GROUP_BATCH_SELECT_SIZE) {
  const picked = [];
  const seen = new Set();
  for (const contact of contacts) {
    if (picked.length >= limit) break;
    const id = contact?.id;
    if (id == null || seen.has(id) || selectedIds.has(id)) continue;
    seen.add(id);
    picked.push(contact);
  }
  return picked;
}

/**
 * Label for the group header action, or null when it should be hidden:
 * a group of <= batch size is covered by the group checkbox, and a fully selected
 * group has nothing left to add.
 */
export function getGroupBatchSelectLabel({
  groupCount = 0,
  selectedInGroup = 0,
  isFullySelected = false,
  batchSize = GROUP_BATCH_SELECT_SIZE,
} = {}) {
  const total = Number(groupCount) || 0;
  if (isFullySelected || total <= batchSize) return null;
  const remaining = Math.max(total - (Number(selectedInGroup) || 0), 0);
  if (remaining === 0) return null;
  const size = Math.min(batchSize, remaining);
  return selectedInGroup > 0 ? `Select next ${size}` : `Select ${size}`;
}
